import type { ReactNode } from 'react'
import { Label } from '@/components/ui/label'
import { cn } from '@/utils/cn'

/** Shared form label look — use for FormField and sky read-only companions (Province / Territory). */
export const FORM_FIELD_LABEL_CLASS =
  'text-[13px] font-semibold tracking-tight text-foreground'

interface FormFieldProps {
  label: string
  htmlFor?: string
  required?: boolean
  error?: string
  hint?: string
  className?: string
  children: ReactNode
}

export function FormField({
  label,
  htmlFor,
  required,
  error,
  hint,
  className,
  children,
}: FormFieldProps) {
  return (
    <div className={cn('space-y-1', className)}>
      <Label htmlFor={htmlFor} className={FORM_FIELD_LABEL_CLASS}>
        {label}
        {required ? (
          <span className="ml-0.5 text-destructive" aria-hidden>
            *
          </span>
        ) : null}
      </Label>
      {children}
      {error ? (
        <p className="text-xs text-destructive" role="alert">
          {error}
        </p>
      ) : hint ? (
        <p className="text-caption">{hint}</p>
      ) : null}
    </div>
  )
}
